import axios from "axios";
import helpers from "@/services/helpers";
export default {
  namespaced: true,
  state: {
    categories: [],
    categorySelects: []
  },
  getters: {
    categories: state => state.categories,
    categorySelects: state => state.categorySelects
  },
  mutations: {
    setCategories(state, payload) {
      state.categories = payload.data;
    },
    setCategorySelect(state, payload) {
      state.categorySelects = payload.data;
    },
    setDeleteCategories(state, payload) {
      state.categories = state.categories.data.filter(
        item => item.id !== payload
      );
    },
    SET_UPDATE_CATEGORY(state, payload) {
      state.categories.data.unshift(payload.data)
      state.categories.total = state.categories.total + 1
      state.categorySelects.unshift(payload.data)

    }
  },
  actions: {
    async get({ commit }, value) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        if (value) {
          const url = value.search
            ? `/api/get-categories?paginated=true&company_id=${value.company_id}&page=${value.currentPage}&per_page=${value.perPage}&search=${value.search}`
            : `/api/get-categories?paginated=true&company_id=${value.company_id}&page=${value.currentPage}&per_page=${value.perPage}`;
          const res = await axios.get(url);
          commit("setCategories", value.search ? res : res.data);
          return res.data;
        } else {
          const res = await axios.get(
            `/api/get-categories?paginated=true&company_id=${value.company_id}`
          );
          commit("setCategories", res.data);
          return res.data;
        }
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async getSelects({ commit }, company_id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        if (company_id) {
          const res = await axios.get(
            `/api/get_categories_by_company/${company_id}`
          );
          commit("setCategorySelect", res.data);
          return res.data;
        } else {
          const res = await axios.get(
            `/api/get-categories`
          );
          commit("setCategorySelect", res.data);
          return res.data;
        }
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async getCategory({ commit }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.get(`/api/categories/${id}`);
        return res.data;
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async createOrUpdate({ commit, dispatch }, payload) {
      const { id } = payload;
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        if (!payload.id) {
          const resp = await axios.post("api/categories", payload);
          commit("SET_UPDATE_CATEGORY", resp.data);
          return resp.data;
        } else {
          const res = await axios.post(
            `api/categories/${payload.id}`,
            payload.data
          );
          return res.data;
        }
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async delete({ commit }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.delete(`api/categories/${id}`);
        res ? commit("setDeleteCategories", id) : ''
        return res.data;
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    }
  }
};
